import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import gql from "graphql-tag";
import { Miscellaneous } from "src/types/graphql.d";

const CHECKOUT_MESSAGE = gql`
  query miscellaneous {
    miscellaneous {
      checkoutMessage
    }
  }
`;

interface CheckoutMessageData {
  miscellaneous: Miscellaneous;
}

interface CheckoutMessageHook {
  data: CheckoutMessageData | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const useCheckoutMessage = (): CheckoutMessageHook => {
  const { data, loading, error } = useQuery<CheckoutMessageData>(
    CHECKOUT_MESSAGE,
    {
      ssr: true,
      fetchPolicy: "cache-first",
    }
  );

  return { data, loading, error };
};

export { useCheckoutMessage };
